import React from 'react';

import { useCreateFace } from '@vlabs/api/artemy/client';
import { PlusIcon } from '@vlabs/icons';
import { FaceCreateFormPoint3 } from '@vlabs/monokit/features/create-face/forms/FaceCreateForm.point3';
import { useModal } from '@vlabs/uikit';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

interface CreateCardFaceProps {
  cardId: string;
  title?: string;
  onSuccess?: VoidFunction;
}

export function CreateCardFace({
  cardId,
  title = undefined,
  onSuccess = undefined,
}: CreateCardFaceProps): React.JSX.Element {
  const { t } = useTranslation();
  const modal = useModal();
  const createFaceMutation = useCreateFace();

  const submitForm = async ({ sdkDescriptor, sampleId }: { sdkDescriptor: string; sampleId: string }) => {
    await createFaceMutation.mutateAsync({
      data: {
        card_id: cardId,
        avatar: `/1/samples/faces/${sampleId}`,
        attribute: {
          face_descriptors: [sdkDescriptor],
          face_descriptor_samples: [sampleId],
        },
      },
    });
    onSuccess?.();
    modal.close();
    toast.success(t('monokit:create face modal.toast.face create success'));
  };

  return (
    <React.Fragment>
      {modal.wrap(<FaceCreateFormPoint3
        closeModal={modal.close}
        onSubmit={submitForm}
      />)}
      <Button
        data-testid="createFaceButton"
        icon={<PlusIcon />}
        kind="primary"
        onClick={modal.open}
        title={title ?? t('monokit:create face modal.forms.buttons.create face')}
        type="button"
      >
        {title ?? t('monokit:create face modal.forms.buttons.create face')}
      </Button>
    </React.Fragment>
  );
}
